<template>
  <div>
    <children-single-select-box
      @balanceChange="changeBalanceId"
    />
    <custom-input
      v-model="amount"
      class="mt-2"
      label="Wpłacona kwota"
      type="number"
      min="1"
    />
    <div class="d-flex justify-content-center">
      <custom-button
        class="accept-button"
        buttonName="Wpłać"
        :disabled="buttonDisabled"
        @click="sendBalance"
      />
    </div>
    <div class="d-flex justify-content-center">
      <p
        class="msg"
        v-if="msg"
      >
        {{ msg }}
      </p>
      <p
        class="error-msg"
        v-if="errorMsg"
      >
        {{ errorMsg }}
      </p>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import axios from 'axios';

import messages from '../../consts/messages';
import { urlBuilder } from '../../plugins/helpers';

import ChildrenSingleSelectBox from '../list/ChildrenSingleSelectBox.vue';
import CustomInput from '../common/CustomInput.vue';
import CustomButton from '../common/CustomButton.vue';

export default {
  name: 'PaymentForm',
  components: { CustomButton, CustomInput, ChildrenSingleSelectBox },
  setup() {
    const balanceId = ref(null);
    const msg = ref('');

    function changeBalanceId(event) {
      balanceId.value = event;
      msg.value = '';
    }

    const amount = ref(null);
    const errorMsg = ref('');

    function validation() {
      errorMsg.value = '';
      let response = true;
      if (!balanceId.value || amount.value < 1) {
        errorMsg.value = messages.no_amount_or_client;
        response = false;
      }
      return response;
    }

    const buttonDisabled = ref(false);

    async function sendBalance() {
      buttonDisabled.value = true;
      if (validation()) {
        const payload = {
          amount: Number(amount.value),
        };
        try {
          await axios.post(urlBuilder(`/balance/${balanceId.value}/deposit/`), payload);
          msg.value = messages.payment_success;
          amount.value = null;
        } catch (err) {
          errorMsg.value = messages.something_wrong;
        }
      }
      buttonDisabled.value = false;
    }

    return {
      amount,
      buttonDisabled,
      changeBalanceId,
      errorMsg,
      msg,
      sendBalance,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';
@import '../../assets/css/errors.scss';

.accept-button {
  background-color: $blue;
  border-radius: 5px;
  border: 1px solid $blue;
  color: $white;
  height: 30px;
  width: 100px;
}

.msg {
  color: forestgreen;
}
</style>
